<template>
  <footer class="app-footer">
    <a href="https://genesisui.com">CopyRight</a> &copy; 2020 <span style="margin-left: 10px;">Powered by <a href="https://www.tnetsoft.cn"></a>硕祺网络</span>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue